<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';
useCheckLandingContent();
const route = useRoute();
const { setReserveType } = useSearchFormStore();
const destination = (route.params.code ?? '') as string;
const taxiSearchForm = useTaxiForm();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: `https://mrbilit.com${route.path.replace(/\/$/, '')}`,
        },
    ],
});

onMounted(async () => {
    await taxiSearchForm.loadLandingSearchParams(destination);
    setReserveType(ReserveType.Taxi);
});
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط سواری', link: '/taxi' },
        { title: 'بلیط سواری $cityName', link: '$routePath' },
    ]),
});
</script>
<template>
    <InformationContainer />
</template>
